import React from 'react';

const Blogs = () => {
    return (
        <div className='h-screen flex justify-center items-center'>
            <h2 className='text-4xl text-orange-400 font-bold uppercase'>Coming Soon</h2>
        </div>
    );
};

export default Blogs;